// extracted by mini-css-extract-plugin
module.exports = {"balance-text":"balance-text-bcb4ef7f1fc72c64543d231530718504","balance-color":"balance-color-d98fe9055c1bd118f78b9e35bb959ce7"};